import React from 'react';
//connect can also be used with functional components if need be
import { connect } from 'react-redux';
//this Link is a component that we use instead of using anchor tags. It is a way to change the route via to="/Whatever",
//which is defined by App.js. Anchor tags are bad because they cause a full page postback. 
//Link allows for Single page applications.
import { Link } from 'react-router-dom';
import useNavigation from '../hooks/use-navigation';
import { useEffect } from 'react';

const NavBar = (props) => {
    const { navBar } = useNavigation();
    //this lifecycle hook runs after the Dom has loaded. useEffect will run each time this component re-renders because useEffect has no second argument.
    //But in this scenario, NavBar never goes out of scope because of where it is located in App.js
    useEffect(() => {
        navBar(window.location.pathname)
    });


    return (
        <div>
            <div>
                <a className="left-align-text" href={`${props.currentFlicker}`}>&#8592;  Return to flickr</a>
                <img src="photography/HomeBanner.png" alt="chris marek photography" width="80%" height="100%" />
            </div>
            <div align="center" >
                <Link onClick={() => navBar("/")} to={`/`} className="photography-nav-spacing" id="slideshow-link">
                    Home
                </Link>
                <Link onClick={() => navBar("/Portfolio")} to={`/Portfolio`} className="photography-nav-spacing" id="portfolio-link">
                    Portfolio
                </Link>
                <Link onClick={() => navBar("/Images")} to={`/Images`} className="photography-nav-spacing" id="images-link">
                    Images
                </Link>
                <Link onClick={() => navBar("/About")} to={`/About`} className="photography-nav-spacing" id="about-link">
                    About
                </Link>
                <Link onClick={() => navBar("/Contact")} to={`/Contact`} className="photography-nav-spacing" id="Contact-link">
                    Contact
                </Link>
                <hr className="navbar set-hr-width" />
            </div >
        </div >
    );
};
const mapStateToProps = (state) => {
    return { currentFlicker: state.fetchCurrentFlickerReducer.currentFlicker };
}
//NOTE action creator(s) if any, included here. . . 
export default connect(mapStateToProps)(NavBar);